import { Main, Models, StatusBadge, EmptyState, StatCard, Assets } from 'utils/imports.utils';
import { useEffect, useRef } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { useSetState, formatViewCount, getAdminUserLabel } from 'utils/functions.utils';
import { AdminProjectDetail, AdminTargetRow } from 'interfaces/admin.interface';
import AdminPage from 'common_components/ui/admin_page/admin_page.ui';
import './admin_project_detail.screen.scss';


const AdminProjectDetailScreen = () => {
  const navigate = useNavigate();
  const { projectId } = useParams();
  const hasLoadedOnce = useRef(false);
  const [state, setState] = useSetState({
    detail: null as AdminProjectDetail | null,
    loading: true,
  });

  const fetchDetail = async () => {
    if (!projectId) return;
    if (!hasLoadedOnce.current) {
      setState({ loading: true });
    }
    try {
      const response: any = await Models.auth.adminGetProjectDetail(projectId);
      setState({ detail: response?.data || null, loading: false });
    } catch (err) {
      console.error('Failed to fetch project detail', err);
      setState({ loading: false });
    } finally {
      hasLoadedOnce.current = true;
    }
  };

  useEffect(() => {
    let token = localStorage.getItem('token');
    if (!token) {
      navigate('/login');
      return;
    }
    fetchDetail();
  }, [projectId]);

  return (
    <Main backgroundColor="#F7F3E9" isRenderOnlyLogo={false} isAdmin>
      <AdminPage breadcrumb="Admin / Projects / Detail">
      <div className="admin_project_detail">
        <img
          src={Assets.arrow}
          alt="Back"
          className="admin_project_detail_back"
          onClick={() => navigate('/admin/projects')}
        />

        {state.detail && (
          <>
            <div className="admin_project_detail_header">
              <div className="admin_project_detail_header_text">
                <h2>{state.detail.project.project_name || 'Project'}</h2>
                <p className="admin_project_detail_owner">Owner: {(state.detail.owner && getAdminUserLabel(state.detail.owner)) || '—'}</p>
              </div>
              {state.detail.project.project_status && (
                <StatusBadge
                  status={state.detail.project.project_status}
                />
              )}
            </div>
            <div className="admin_project_detail_stats">
              <StatCard
                label="Total views"
                value={formatViewCount(
                  state.detail.targets.reduce((sum: number, target: AdminTargetRow) => sum + (target.total_views || 0), 0)
                )}
              />
              <StatCard label="Targets" value={state.detail.targets.length} />
            </div>

            <div className="admin_project_detail_card">
            <h3 className="admin_project_detail_targets_title">Target images</h3>
            {state.detail.targets.length === 0 ? (
              <EmptyState message="No target images in this project" />
            ) : (
              <div className="admin_project_detail_targets">
                {state.detail.targets.map((target: AdminTargetRow) => (
                  <div className="admin_project_detail_target_card" key={target._id}>
                    <img
                      src={target.image_url || Assets.image_placeholder}
                      alt="Target"
                      className="admin_project_detail_target_thumb"
                    />
                    <div className="admin_project_detail_target_body">
                      <span className="admin_project_detail_target_views">
                        {formatViewCount(target.total_views)}
                      </span>
                      <span className="admin_project_detail_target_label">views</span>
                      <span className="admin_project_detail_target_last_viewed">
                        {target.last_viewed_at
                          ? `Last viewed ${new Date(target.last_viewed_at).toLocaleDateString()}`
                          : 'Never viewed'}
                      </span>
                    </div>
                  </div>
                ))}
              </div>
            )}
            </div>
          </>
        )}
      </div>
      </AdminPage>
    </Main>
  );
};

export default AdminProjectDetailScreen;
